/**
 * Request Cancellation Utility
 * Manages AbortControllers for all active API requests
 * Allows cancellation of all requests during logout
 */

let abortControllers: Set<AbortController> = new Set();
let isLoggingOutFlag = false;

/**
 * Register an AbortController to be tracked
 */
export function registerAbortController(controller: AbortController): void {
  abortControllers.add(controller);
}

/**
 * Unregister an AbortController
 */
export function unregisterAbortController(controller: AbortController): void {
  abortControllers.delete(controller);
}

/**
 * Cancel all active requests
 */
export function cancelAllRequests(): void {
  abortControllers.forEach(controller => {
    try {
      controller.abort();
    } catch (error) {
      // Ignore errors when aborting
    }
  });
  abortControllers.clear();
}

/**
 * Set the global logging out flag
 */
export function setLoggingOutFlag(value: boolean): void {
  isLoggingOutFlag = value;
}

/**
 * Check if logout is in progress
 */
export function isLoggingOut(): boolean {
  return isLoggingOutFlag;
}

/**
 * Reset the logging out flag (for testing or error recovery)
 */
export function resetLoggingOutFlag(): void {
  isLoggingOutFlag = false;
}

/**
 * Get count of active requests (for debugging)
 */
export function getActiveRequestCount(): number {
  return abortControllers.size;
}

